"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrowserProvider = BrowserProvider;
exports.useBrowser = useBrowser;

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _bowser = _interopRequireDefault(require("bowser"));

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Browser context.
 */
var BrowserContext = /*#__PURE__*/(0, _react.createContext)();
/**
 * Export `useBrowser`.
 */

function useBrowser() {
  var browser = (0, _react.useContext)(BrowserContext);

  if (!browser) {
    throw new Error('Missing browser context');
  }

  return browser;
}
/**
 * `BrowserProviderProps` type.
 */


/**
 * Parse browser.
 */
var parseBrowser = (0, _memoize2["default"])(function (userAgent) {
  return _bowser["default"].getParser(userAgent);
});
/**
 * Export `BrowserProvider` component.
 */

function BrowserProvider(props) {
  var children = props.children,
      userAgent = props.userAgent;
  return /*#__PURE__*/_react["default"].createElement(BrowserContext.Provider, {
    value: parseBrowser(userAgent)
  }, children);
}